import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector, useDispatch} from "react-redux";

//helpers:
import {getTranslatedGroupName} from "../../../../../_metronic/_helpers";

//actions:
import {
    selectAllGroups,
    selectGroupsStatus,
    selectInvitations,
    setModifiedEmails,
} from "../../../../redux_slices/settingsCredentialsSlice";

//components:
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {Dropdown} from "react-bootstrap";
import {CustomTooltip} from "../../../../widgets";
import {CircularProgress} from "@material-ui/core";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const useEmailsTable = () => {
    const {t} = useTranslation();

    //redux:
    const dispatch = useDispatch();
    const allGroups = useSelector(selectAllGroups);
    const {type, error} = useSelector(selectGroupsStatus);
    const {modified = []} = useSelector(selectInvitations);

    const updateEmail = email => {
        if (email) {
            try {
                const updatedEmail = modified.map(em => (em.email === email.email ? email : em));
                dispatch(setModifiedEmails(updatedEmail));
            } catch (err) {
                console.error("Failed to update email group ", err);
            }
        }
    };

    const deleteEmail = email => {
        if (email) {
            const restOfEmails = modified.filter(em => em.email !== email.email);
            dispatch(setModifiedEmails(restOfEmails));
        }
    };

    const renderDropdown = (row = {}) => {
        const {group = {}} = row;

        const isLoadingDropdown = () => type === "idle" || type === "loading";

        if (isLoadingDropdown())
            return (
                <div className="d-flex w-100 h-100">
                    <CircularProgress className="m-auto" />
                </div>
            );
        else if (error?.text) return <div className="alert alert-light text-dark w-fit-content">{error.text}</div>;

        return (
            <Dropdown>
                <CustomTooltip
                    config={{
                        text: t("ADMINPANEL.USERS.TYPE.SELECTOR.TOOLTIP"),
                        placement: "top",
                    }}
                >
                    <Dropdown.Toggle variant="light">
                        {getTranslatedGroupName(t, group)} <KeyboardArrowDownIcon />
                    </Dropdown.Toggle>
                </CustomTooltip>

                <Dropdown.Menu className="tables_dropdown_list p-2">
                    {allGroups?.length ? (
                        allGroups.map((gr, i) => (
                            <Dropdown.Item
                                key={i}
                                className="dropdown-item elipsis_1line"
                                onClick={() => updateEmail({...row, group: gr})}
                                active={group.group_id ? group.group_id === gr.group_id : gr.group_id === 1}
                            >
                                {getTranslatedGroupName(t, gr)}
                            </Dropdown.Item>
                        ))
                    ) : (
                        <span>{t("ADMINPANEL.TRACKS.TABLE.VIDEOS_EMPTY")}</span>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    const formatRow = (row, i) => {
        const {email = "", valid = false} = row;
        return (
            <TableRow key={i}>
                <TableCell align="left" component="th" scope="row" style={{minWidth: 200, maxWidth: 400}}>
                    <div className="d-flex align-items-center">
                        <div
                            className="w-40px h-40px my-4 mr-4 rounded-circle border border-gray shadow bg_image_cover"
                            style={{backgroundImage: "url('/media/avatars/dummy-avatar.jpg')"}}
                        />
                        <div className="d-flex flex-column">
                            <div className="text-dark-75 font-size-base mb-0">{email}</div>
                            {!valid ? <div className="text-danger">{t("ADMINPANEL.USERS.EMAIL.EXISTS")}</div> : null}
                        </div>
                    </div>
                </TableCell>

                {valid ? (
                    <>
                        <TableCell align="left" className="mb-0 font-size-1rem">
                            <div className="d-flex align-items-center">{renderDropdown(row)}</div>
                        </TableCell>

                        <TableCell align="right">
                            <CustomTooltip
                                config={{
                                    text: t("ADMINPANEL.USERS.TABLE.DELETE.TOOLTIP"),
                                    placement: "top",
                                }}
                            >
                                <button
                                    type="button"
                                    className="close ml-auto font-size-base"
                                    aria-label="Close"
                                    onClick={() => deleteEmail(row)}
                                >
                                    <HighlightOffRoundedIcon />
                                </button>
                            </CustomTooltip>
                        </TableCell>
                    </>
                ) : null}
            </TableRow>
        );
    };

    return {
        formatRow,
    };
};

export default useEmailsTable;
